import { Component, Input } from '@angular/core';

@Component({
  selector: 'piqet-angular-toc-list',
  templateUrl: './toc-list.component.html',
  styleUrls: ['./toc-list.component.scss'],
})
export class TocListComponent {
  @Input() title: string = ''; // Can be 'Figures' or 'Tables'
  @Input() indexList: string[] = []; // This can be figureIndexList or tableIndexList
  @Input() checkWidth: boolean = false;
  scrollToElement(elementId: string) {
    const element = document.getElementById(elementId);
    if (element) {
      const y = element.getBoundingClientRect().top + window.pageYOffset - 200;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }
}
